import getCollectionData from './get-collection-data';
import getTranslationsData from './get-translations-data';

export { getTranslationsData, getCollectionData };
